import React, { useState } from "react";
import Header from "../Layouts/Header";
import Footer from "../Layouts/Footer";
import bgImage from "../Assets/Images/TestimonialsBgIMG.jpg";
import CircularText from "../Components/CircularText";
import { FaArrowDown } from "react-icons/fa";
import { motion } from "framer-motion";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import ThiruImg from '../Assets/Images/Thiru Img 2.jpg';
import SanthoshImg from '../Assets/Images/Santhosh Kumar Img.jpg';
import AcciImg from '../Assets/Images/ACCI Img.jpg';
import kalidossImg from '../Assets/Images/Kalidoss Img.jpg';
import LogeshImg from '../Assets/Images/LogeshImg.jpg';
import SoundarImg from '../Assets/Images/SoundarImg.jpeg';

// Testimonials Data
const testimonials = [
  {
    image: SanthoshImg,
    title: "Mr. Santhosh Kumar M, CEO of Thanshi Capital Service, Madurai",
    text1:
      "Viveka Softek has been a reliable tech partner for us. Their team delivered a tailored system that simplified our client management and operational workflow.",
    text2:
      "We value their timely delivery, strong technical expertise, and excellent customer support.",
  },
  {
  image: LogeshImg,
  title: "Mr. Lokesh Babu, CEO of Spark Logistics",
  text1:
    "Partnering with this IT team has truly transformed our logistics operations. Their innovative solutions have streamlined our workflows and enhanced our customer experience.",
  text2:
    "Their commitment to quality, timely delivery, and ongoing support has made them a trusted technology partner for Spark Cargo’s digital growth.",
},

  {
  image: AcciImg,
  title: "Mr. Muthusonnai, Managing Director of Acci Forum",
  text1:
    "The forum management software developed by this team has streamlined our member engagement and event coordination.",
  text2:
    "Their innovative platform has made communication seamless, enabling our community to stay connected, informed, and productive.",
},

  {
  image: kalidossImg,
  title: "Mr. Kalidoss, CEO of NP Builders",
  text1:
    "The custom construction management software developed by this team has greatly simplified our project tracking and on-site coordination.",
  text2:
    "Their innovative solutions and prompt support have enhanced our efficiency, helping NP Builders deliver projects on time with improved collaboration.",
},
  {
    image: ThiruImg,
    title: "Mr. Thirunavukkarasar, CEO of Sai Villas",
    text1:
      "Sai Villas delivered our project with exceptional quality and on-time completion. Their team maintained full transparency and professionalism throughout the process.",
    text2:
      "I truly appreciate their commitment, innovative approach, and attention to every detail — Sai Villas is a name you can trust for any construction need.",
  },
  {
    image: SoundarImg,
    title: "Mr. Soundar Nallasamy, Founder – Sowmi Navira Bridal House",
    text1:
      "I chose Vivekasoftek because they took the time to understand my business before discussing payment. They listened to my requirements, understood my vision, and delivered a working demo that exceeded my expectations.",
    text2:
      "Throughout the project, they responded quickly to every update and requirement with professionalism and dedication. Their focus was always on finding the right solution rather than just completing the project.",
    text3:
    "I confidently recommend Vivekasoftek to any business looking for a trusted software development partner.Real trust is earned through quality, commitment, and results." 
    },
];

// ✅ TestimonialCard Component
const TestimonialCard = ({ image, title, text1, text2, reverse, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.2, delay: index * 0.2 }}
    viewport={{ once: true }}
    className={`flex flex-col md:flex-row items-center gap-10 ${reverse ? "md:flex-row-reverse" : ""
      }`}
  >
    {/* Image Section */}
    <div
      className={`relative bg-gray-900 overflow-hidden shadow-lg w-full md:w-1/2 rounded-xl ${reverse ? "clip-diagonal-left" : "clip-diagonal-right"
        }`}
    >
      <img
        src={image}
        alt={`Testimonial - ${title}`}
        loading="lazy"
        className="w-full h-[250px] md:h-[350px] lg:h-[350px] object-cover"
      />
    </div>

    {/* Text Section */}
    <div className="w-full md:w-1/2 text-center md:text-left">
      <h2 className="text-2xl md:text-3xl font-bold mb-4">{title}</h2>
      <p className="text-gray-300 mb-4">{text1}</p>
      <p className="text-gray-400">{text2}</p>
    </div>
  </motion.div>
);

// ✅ Main Component
const Testimonials = () => {
  const [visibleCount, setVisibleCount] = useState(3);

  const handleScroll = () => {
    const section = document.getElementById("scrollDown");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const loadMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <div
        className="relative min-h-screen flex flex-col justify-center items-center text-white"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-65"></div>

        {/* Content */}
        <div className="relative z-10 text-center px-4 md:px-0 pb-32 space-y-4">
          <p className="text-4xl md:text-6xl font-bold leading-tight">
            Testimonials
          </p>
          <div className="mx-auto w-24 h-1 bg-white"></div>
          <h2 className="text-lg md:text-2xl font-normal mt-2">
            Ties the personal transformation directly to the company{" "}
            <span className="font-bold">VIVEKASOFTEK</span>
          </h2>
        </div>

        {/* Scroll Down */}
        <div className="relative flex items-center justify-center mt-10">
          <div
            onClick={handleScroll}
            className="absolute top-0 left-0 w-full h-full flex items-center justify-center cursor-pointer"
          >
            <CircularText text="VIVEKASOFTEK @ EXPLORE " spinDuration={20} />
          </div>
          <div className="z-10 flex items-center justify-center">
            <button onClick={handleScroll} aria-label="Scroll down">
              <FaArrowDown size={28} className="text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <section id="scrollDown" className="bg-black text-white pt-28 pb-20 px-6">
        <div className="max-w-6xl mx-auto space-y-20">
          {testimonials.slice(0, visibleCount).map((t, index) => (
            <TestimonialCard
              key={index}
              image={t.image}
              title={t.title}
              text1={t.text1}
              text2={t.text2}
              reverse={index % 2 === 1}
              index={index}
            />
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < testimonials.length && (
          <div className="flex justify-center mt-12">
            <button
              onClick={loadMore}
              className="px-6 py-3 bg-white text-black font-semibold rounded-xl shadow-lg hover:bg-gray-200 transition flex items-center gap-2"
            >
              Load More <MdKeyboardDoubleArrowDown />
            </button>

          </div>
        )}
      </section>

      <Footer />
    </>
  );
};

export default Testimonials;